import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faEnvelope, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, Container, InputGroup, Alert, Image } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../../routes";
import BgImage from "../../assets/img/illustrations/signin.svg";
import ProductivosLogo from "../../assets/img/productivos-logo.png";
import api from "../../api/api";

export default () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      // Call the forgot password API endpoint
      const response = await api.post('/api/user/forgot-password', null, {
        params: { email }
      });

      setSuccess(true);
      setEmail(""); // Clear the email field
    } catch (err) {
      console.error('Forgot password error:', err);

      // Extract error message from API response
      let errorMessage = 'No se pudo procesar la solicitud. Por favor, intente más tarde.';

      if (err.response?.data) {
        if (typeof err.response.data === 'string') {
          errorMessage = err.response.data;
        } else if (err.response.data.message) {
          errorMessage = err.response.data.message;
        }
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <p className="text-center">
            <Card.Link as={Link} to={Routes.Signin.path} className="text-gray-700">
              <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Volver al inicio de sesión
            </Card.Link>
          </p>
          <Row className="justify-content-center form-bg-image" style={{ backgroundImage: `url(${BgImage})` }}>
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <Image src={ProductivosLogo} alt="Productivos.org" style={{ height: '60px', marginBottom: '20px' }} />
                  <h3 className="mb-0">¿Olvidaste tu contraseña?</h3>
                  <p className="text-muted mt-2">
                    No te preocupes, ingresa tu correo electrónico y te enviaremos un código para restablecer tu contraseña.
                  </p>
                </div>

                {success && (
                  <Alert variant="success">
                    <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                    <strong>¡Correo enviado exitosamente!</strong>
                    <p className="mb-0 mt-2">
                      Hemos enviado un código de recuperación a tu correo electrónico.
                      Por favor, revisa tu bandeja de entrada y sigue las instrucciones.
                    </p>
                  </Alert>
                )}

                {error && (
                  <Alert variant="danger" onClose={() => setError("")} dismissible>
                    <strong>Error</strong>
                    <p className="mb-0 mt-2">{error}</p>
                  </Alert>
                )}

                {!success && (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group id="email" className="mb-4">
                      <Form.Label>Correo Electrónico</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faEnvelope} />
                        </InputGroup.Text>
                        <Form.Control
                          autoFocus
                          required
                          type="email"
                          placeholder="ejemplo@empresa.com"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </InputGroup>
                    </Form.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100"
                      disabled={loading}
                    >
                      {loading ? 'Enviando...' : 'Recuperar Contraseña'}
                    </Button>
                  </Form>
                )}

                {success && (
                  <div className="mt-3">
                    <Button
                      variant="outline-primary"
                      className="w-100"
                      onClick={() => setSuccess(false)}
                    >
                      Enviar otro código
                    </Button>
                  </div>
                )}

                <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    ¿Recordaste tu contraseña?
                    <Card.Link as={Link} to={Routes.Signin.path} className="fw-bold">
                      {` Iniciar sesión `}
                    </Card.Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
